<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //

    import SwbQuerySortArea from '../query/QuerySortArea';

    Vue.regist(SwbQuerySortArea);

    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "label": "招标编号",
                "code": "no",
                "valueType": "String",
                "basic": true
            },
            {
                "type": "Text",
                "label": "招标标题",
                "code": "title",
                "basic": true,
                "valueType": "String"
            },
            {
                "type": "Date2",
                "valueType": "Date",
                "label": "发布日期",
                "code": "publishTime",
                "basic": true
            },
            {
                "type": "Date2",
                "label": "报名截至日期 ",
                "valueType": "String",
                "code": "enrollCloseTime"
            },
            {
                "type": "Date2",
                "label": "投标截止日期",
                "valueType": "String",
                "code": "closeTime"
            },
            {
                "type": "Select",
                "label": "招标类型",
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "goods",
                        "label": "商品"
                    },
                    {
                        "value": "servc",
                        "label": "服务"
                    },
                    {
                        "value": "Integ",
                        "label": "集成"
                    }
                ],
                "code": "tradeType",
                "valueType": "String"
            }
        ],
        "sortFields": [
            {
                "label": "发布日期",
                "code": "publishTime",
                "order": "desc",
                "enabled": true
            },
            {
                "label": "报名截至时间",
                "code": "enrollCloseTime",
                "order": "desc",
                "enabled": true
            },
            {
                "label": "投标截至时间",
                "code": "closeTime",
                "order": "desc",
                "enabled": true
            }
        ]
    };

    export default {
        name: 'swb-call-bid-list-search',
        desc: '查询招投标搜索',
        props:['no'],
        data: function () {
            return {
                queryConfig: null,
                queryKey:null,
                queryConfigMap: {}
            }
        },
        created: function () {
            //查询排序配置信息
            let queryConfig = searchConfigData || {};
            //查询回调函数调用上下文对象
            //queryConfig.queryContext = this;
            //...
            this.queryConfig = queryConfig;

            this.queryConfigMap = queryConfig.queryFields.toMap("code");

            if(!Utils.isNoB(this.no)) {
                let queryConfigOb = this.queryConfigMap["no"];
                queryConfigOb.value = this.no;
            }
        },
        methods: {
            queryHandler(queryModel) {
                console.log('----------  查询、排序参数 ---------');

                this.$emit("showCallBidCallSearch", queryModel)
                //调用查询...
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/callbid/CallBidDocListSearch.vue